import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

const FilePreview = ({ path }) => (
  <embed
    key={path}
    src={path}
    sandbox="allow-same-origin allow-scripts"
    style={{width: "100%", height: "100%", display: "block"}}  
  />
);

FilePreview.propTypes = {
  path: PropTypes.string,
  token: PropTypes.string,
};

export default connect(
  state => ({
    token: state.user.profile.token,
  }),
)(FilePreview);